import type { Contexts } from '@sentry/core';

export const validate = <R, K extends keyof NonNullable<R>>(
  response: R | undefined | string,
  responseKey: K,
  contexts: Contexts
): NonNullable<NonNullable<R>[K]> | undefined => {
  // server has a 500 and returns "internal server error" as body.
  if (!response || typeof response === 'string' || typeof response === 'undefined') {
    captureMessage(`[Goliath]: ${response || 'Returned unexpected response'}`, 'info', {
      captureContext: {
        contexts: {
          ...contexts,
          extra: response as any,
        },
      },
    });

    throw createError({
      statusCode: 500,
      statusMessage: `[Goliath]: ${response || 'Returned unexpected response'}`,
    });
  }

  if (response[responseKey]) {
    return response[responseKey] as NonNullable<NonNullable<R>[K]>;
  }

  const e = new Error(
    `No suitable response received from goliath. Missing response payload "${String(responseKey)}"`
  );
  captureException(e, {
    captureContext: {
      contexts: {
        ...contexts,
        response: JSON.stringify(response) as any,
      },
    },
  });
  throw e;
};
